import { render, staticRenderFns } from "./NewEditSeriePage.vue?vue&type=template&id=6b7feedd&scoped=true"
import script from "./NewEditSeriePage.vue?vue&type=script&lang=js"
export * from "./NewEditSeriePage.vue?vue&type=script&lang=js"
import style0 from "./NewEditSeriePage.vue?vue&type=style&index=0&id=6b7feedd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7feedd",
  null
  
)

export default component.exports